import React from 'react';

import {
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

const ReactHookFormSelect = ({
    control,
    disabled,
    fullWidth = true,
    id,
    label = '',
    name,
    onChange,
    options,
    sx,
    sxFormControl = {},
    variant,
}) => (
    <Controller
        control={control}
        name={name}
        render={({ field, fieldState: { error } }) => {
            const valueIsBetweenTheOptions = options.some(
                (option) => option.value === field.value,
            );

            return (
                <FormControl
                    error={Boolean(error)}
                    fullWidth={fullWidth}
                    size="small"
                    sx={sxFormControl}
                    variant={variant}
                >
                    {label && (
                        <InputLabel
                            {...(field?.value &&
                                valueIsBetweenTheOptions && {
                                    shrink: Boolean(field.value),
                                })}
                        >
                            {label}
                        </InputLabel>
                    )}
                    <Select
                        disabled={disabled}
                        displayEmpty={label === ''}
                        id={id}
                        label={label}
                        {...field}
                        onChange={(e) => {
                            field.onChange(e);
                            if (onChange) onChange(e);
                        }}
                        sx={sx}
                        value={
                            field.value !== null && valueIsBetweenTheOptions
                                ? field.value
                                : ''
                        }
                    >
                        {options.map(
                            ({
                                disabled: optionDisabled,
                                label,
                                sxItem = {},
                                value,
                                visible = true,
                            }) =>
                                visible ? (
                                    <MenuItem
                                        disabled={optionDisabled}
                                        key={`select-${value}-${label}`}
                                        sx={sxItem}
                                        value={value}
                                    >
                                        {label}
                                    </MenuItem>
                                ) : null,
                        )}
                    </Select>
                    {Boolean(error) && (
                        <FormHelperText>{error?.message}</FormHelperText>
                    )}
                </FormControl>
            );
        }}
    />
);

ReactHookFormSelect.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    id: PropTypes.string,
    ignore: PropTypes.array,
    label: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array,
    required: PropTypes.bool,
    sx: PropTypes.object,
    sxFormControl: PropTypes.object,
    variant: PropTypes.string,
};

export default ReactHookFormSelect;
